import { PeerInfo } from "../types/clientTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store/store";

type PeerState = {
  peers: PeerInfo[];
};

const initialState: PeerState = {
  peers: [],
};

export interface ChangeNameProp {
  socketId: string;
  name: string;
}

export interface ISettingProp {
  socketId: string;
  enable: boolean;
}

export const peerSlice = createSlice({
  name: "peer",
  initialState,
  reducers: {
    setPeers: (state: PeerState, action: PayloadAction<PeerInfo[]>) => {
      console.log("debug ===> store setPeers");
      state.peers = [...action.payload];
    },
    addPeer: (state: PeerState, action: PayloadAction<PeerInfo>) => {
      console.log("debug ===> store addPeer");
      if (action.payload.isHost) {
        state.peers.unshift(action.payload);
      } else {
        state.peers.push(action.payload);
      }

      // // userorder 순으로 정렬한다.
      // state.peers.sort((a, b) => {
      //   const aOrder = a.userInfo.userorder ?? Number.MAX_SAFE_INTEGER;
      //   const bOrder = b.userInfo.userorder ?? Number.MAX_SAFE_INTEGER;
      //   return aOrder - bOrder;
      // });
    },
    removePeer: (state: PeerState, action: PayloadAction<string>) => {
      console.log("debug ===> store removePeer");
      state.peers = state.peers.filter(item => item.socketId !== action.payload);
    },
    clearPeer: (state: PeerState) => {
      console.log("debug ===> store clearPeer");
      state.peers = [];
    },
    changeName: (state: PeerState, action: PayloadAction<ChangeNameProp>) => {
      console.log("debug ===> store changeName");
      const find = state.peers.filter(item => item.socketId === action.payload.socketId);
      if (find.length > 0) {
        state.peers = state.peers.filter(item => item.socketId !== action.payload.socketId);
        find.forEach(item => {
          item.userInfo.username = action.payload.name;
          state.peers.push(item);
        });
      }
    },
    changeHostBid: (state: PeerState, action: PayloadAction<string>) => {
      console.log("debug ===> store changeHostBid");
      const newArray = state.peers;

      newArray.forEach(item => {
        item.isHost = item.peerId === action.payload;
      });

      state.peers = [...newArray];
    },
    setCamEnabled: (state: PeerState, action: PayloadAction<ISettingProp>) => {
      console.log("debug ===> store setCamEnabled");
      // console.log('store setCamEnabled', action.payload);
      // state.array.map(item => (item.socketId === action.payload.socketId ? { ...item, isCamEnable: action.payload.enable } : item));

      state.peers.forEach(item => {
        if (item.socketId === action.payload.socketId) {
          item.isCamEnable = action.payload.enable;
        }
      });

      // state.peers = [...state.peers];
    },
    setMicEnabled: (state: PeerState, action: PayloadAction<ISettingProp>) => {
      console.log("debug ===> store setMicEnabled");
      // state.array.map(item => (item.socketId === action.payload.socketId ? { ...item, isMicEnable: action.payload.enable } : item));
      state.peers.forEach(item => {
        if (item.socketId === action.payload.socketId) {
          item.isMicEnable = action.payload.enable ?? false;
        }
      });

      // state.peers = [...state.peers];
    },
    setDisplayFirst: (state: PeerState, action: PayloadAction<{ socketId: string }>) => {
      console.log("debug ===> store setDisplayFirst");

      const find = state.peers.find(item => item.socketId === action.payload.socketId);
      if (find) {
        const moved = [find, ...state.peers.filter(item => item.socketId !== action.payload.socketId)];

        if (moved) {
          state.peers = [...moved];
        }
      }
    },
    // setIsVisible: (state: PeerState, action: PayloadAction<ISettingProp>) => {
    //   console.count("debug ===> store setIsVisible");
    //   state.peers.forEach(item => {
    //     if (item.socketId === action.payload.socketId) {
    //       item.isVisible = action.payload.enable ?? false;
    //       console.log("############# setIsVisible", item.userInfo.username, item.isVisible);
    //     }
    //   });
    // },
  },
});

export const { setPeers, addPeer, removePeer, clearPeer, changeName, changeHostBid, setCamEnabled, setMicEnabled, setDisplayFirst } =
  peerSlice.actions;
export const selectPeers = (state: RootState) => state.peer.peers;

export default peerSlice.reducer;
